import { mealRecords as initialRecords, type MealRecord } from "@/mocks/records";

let records: MealRecord[] = [...initialRecords];
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((fn) => fn());
}

export function getRecords(): MealRecord[] {
  return records;
}

export function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function addRecord(r: MealRecord) {
  records = [r, ...records];
  emit();
}

export function updateRecord(id: string, patch: Partial<MealRecord>) {
  records = records.map((x) => (x.id === id ? { ...x, ...patch } : x));
  emit();
}

export function deleteRecord(id: string) {
  records = records.filter((x) => x.id !== id);
  emit();
}